import SavingAlaskaPage from '../savingAlaska/savingAlaskaPage';

export default [
  {
    path: 'bookForADoctor/:token',
    name: 'savingAlaska',
    component: SavingAlaskaPage,
  },
];
